/**
 * Which avatar provider this browser is trialling, if any: ?avatar=simli or
 * ?avatar=liveavatar switches it on and remembers it; ?avatar=off switches it
 * off. Nobody else sees a change.
 *
 * Kept apart from useAvatar.js, which loads the providers' code, because the
 * app also calls this the moment any page loads (index.js): signing in always
 * lands on /chat, so a trial link opened while signed out lost its ?avatar=
 * before the interview page could read it.
 */
export const AVATAR_PROVIDERS = ['simli', 'liveavatar'];
const TRIAL_KEY = 'ivori-interview-avatar';

export function avatarTrialProvider(search) {
  const asked = new URLSearchParams(search || '').get('avatar');
  try {
    if (asked === 'off') localStorage.removeItem(TRIAL_KEY);
    else if (AVATAR_PROVIDERS.includes(asked)) localStorage.setItem(TRIAL_KEY, asked);
    const kept = localStorage.getItem(TRIAL_KEY);
    return AVATAR_PROVIDERS.includes(kept) ? kept : null;
  } catch {
    return AVATAR_PROVIDERS.includes(asked) ? asked : null;
  }
}
